import axios from "axios";
import {BaseResponse} from "../../BaseResponse";
import {TankCheckDefault} from "./getTankCheckDefaultList";

export async function putTankCheckDefaultList(defaultList: TankCheckDefault[]) {

    const response = await axios.put<BaseResponse<string>>('/tank/check/default', defaultList)

    return response.data
}